<template>
  <el-select
    v-model="purchasesInvoiceModel"
    @change="purchasesInvoiceChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.PURCHASES_INVOICE')"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    remote
    :remote-method="getPurchasesInvoices"
    :loading="loading"
  >
    <el-option
      v-if="showAll"
      :value="null"
      :label="$t('COMMON.PURCHASES_INVOICE')"
    >
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
    </el-option>
    <el-option
      v-for="purchasesInvoice in purchasesInvoices"
      :key="purchasesInvoice.id"
      :value="purchasesInvoice.id"
      :label="`${
        purchasesInvoice.seq_number
          ? purchasesInvoice.seq_number
          : purchasesInvoice.code
      }`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "purchases-invoice-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    purchasesInvoice: {
      type: String,
      default: null,
      description: "PurchasesInvoice id",
    },
    filterReseller: {
      type: String,
      default: null,
      description: "Reseller id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterStatus: {
      type: String,
      default: null,
      description: "PurchasesInvoice status",
    },
    filterServiceCenter: {
      type: String,
      default: null,
      description: "PurchasesOrder service center",
    },
    filterEstablishment: {
      type: String,
      default: null,
      description: "PurchasesOrder establishment",
    },
    filterCafeteria: {
      type: String,
      default: null,
      description: "PurchasesOrder cafeteria",
    },
  },

  data() {
    return {
      purchasesInvoiceModel: this.purchasesInvoice,
      purchasesInvoices: {},
    };
  },

  setup() {},

  created() {
    this.getPurchasesInvoices(null, this.purchasesInvoice);
  },

  methods: {
    async getPurchasesInvoices(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "-created_at",
          filter: {
            ...(query ? { code: query } : {}),
            ...(id ? { id: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
          include: "paymentTerm",
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }
        if (this.filterReseller) {
          params = {
            ...params,
            filter: { ...params.filter, reseller: this.filterReseller },
          };
        }
        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.filterStatus) {
          params = {
            ...params,
            filter: { ...params.filter, status: this.filterStatus },
          };
        }
        if (this.filterServiceCenter) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              serviceCenter: this.filterServiceCenter,
            },
          };
        }
        if (this.filterEstablishment) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              establishment: this.filterEstablishment,
            },
          };
        }
        if (this.filterCafeteria) {
          params = {
            ...params,
            filter: { ...params.filter, cafeteria: this.filterCafeteria },
          };
        }

        await this.$store.dispatch("purchasesInvoices/list", params);
        const purchasesInvoicesArr = await this.$store.getters[
          "purchasesInvoices/list"
        ];
        this.purchasesInvoices = {};
        purchasesInvoicesArr.forEach((purchasesInvoice) => {
          this.purchasesInvoices[purchasesInvoice.id] = purchasesInvoice;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    purchasesInvoiceChanged(purchasesInvoiceId) {
      const puchaseInvoice = Object.values(this.purchasesInvoices).find(
        (item) => item.id === purchasesInvoiceId
      );
      this.$emit("purchasesInvoiceChanged", purchasesInvoiceId, puchaseInvoice);
    },
  },

  watch: {
    purchasesInvoice(purchasesInvoice) {
      if (purchasesInvoice) {
        this.purchasesInvoiceModel = purchasesInvoice;
        if (purchasesInvoice !== this.purchasesInvoiceModel) {
          this.getPurchasesInvoices(null, purchasesInvoice);
        }
      } else {
        this.purchasesInvoiceModel = null;
      }
    },
    filterOrganization(filterOrganization) {
      this.getPurchasesInvoices();
    },
    filterReseller() {
      this.getPurchasesInvoices();
    },
    filterStatus() {
      this.getPurchasesInvoices();
    },
    filterServiceCenter() {
      this.getPurchasesInvoices();
    },
    filterEstablishment() {
      this.getPurchasesInvoices();
    },
    filterCafeteria() {
      this.getPurchasesInvoices();
    },
  },
};
</script>
